import axios from 'axios';

/* External */

/* Constants */
var BASE_URL = '/bin/ott';

/**
 * @typedef AemAxiosInstanceCreatorParams
 * @type {object}
 * @property {string} host
 */

/**
 * @param {AemAxiosInstanceCreatorParams} param0
 */
function createAxiosInstance(_ref) {
  var host = _ref.host;
  var aemAxiosInstance = axios.create({
    baseURL: "".concat(host).concat(BASE_URL)
  });
  return aemAxiosInstance;
}

export { createAxiosInstance as default };
//# sourceMappingURL=createAxiosInstance.js.map
